<div class="visit-table-cell-checkbox">
  <div>
    <label class="checkbox">
      <input type="checkbox" (click)="onItemSelected($event)" [checked]="checked">
      <span></span>
    </label>
  </div>
</div>
